import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "illustration", "body", "heading", "size"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef, useMemo, createElement, cloneElement, useContext, createContext } from 'react';
import styles from './empty-state.module.js';
import { Button } from '../button/button.js';
import { Link } from '../primitives/link/link.js';
var DEFAULT_SIZE = 'large';
var EmptyStateContext = /*#__PURE__*/createContext({
  size: DEFAULT_SIZE
});
var EmptyStateComponent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      className = props.className,
      illustration = props.illustration,
      body = props.body,
      heading = props.heading,
      _props$size = props.size,
      size = _props$size === void 0 ? DEFAULT_SIZE : _props$size,
      rest = _objectWithoutProperties(props, _excluded);

  var value = useMemo(function () {
    return {
      size: size
    };
  }, [size]);
  return jsx(EmptyStateContext.Provider, {
    value: value,
    children: jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
      ref: forwardedRef,
      className: clsx(styles.emptyState, styles[size], className),
      role: "group",
      children: [jsx("div", {
        className: styles.illustration,
        children: /*#__PURE__*/createElement(illustration, {
          role: 'presentation',
          width: '8.75rem',
          height: '8.75rem'
        })
      }), heading ? /*#__PURE__*/cloneElement(heading, {
        className: styles.heading,
        variant: size === 'small' ? 'titleSmall' : 'titleMedium'
      }) : null, /*#__PURE__*/cloneElement(body, {
        className: styles.body
      }), children]
    }))
  });
});
var PrimaryAction = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useContext = useContext(EmptyStateContext),
      size = _useContext.size;

  return jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: styles.button,
    size: size,
    variant: "secondary",
    children: children
  }));
});
var SecondaryAction = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded3);

  return jsx(Link, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    children: children
  }));
});
/**
 * Empty states refer to "placeholders" displayed when there is no actual data to show to the user.
 They are most commonly seen the first time a user interacts with a product or page, but can be used when data has been deleted or is unavailable.  They can be a part of an empty page, sidebar or popover.
 *
 */

var EmptyState = Object.assign(EmptyStateComponent, {
  /**
   * The component that displays a primary action.
   */
  PrimaryAction: PrimaryAction,

  /**
   * The component that displays a secondary action.
   */
  SecondaryAction: SecondaryAction
});
export { EmptyState };